import {OrderItem} from "./OrderItem";
import {Order} from "./Order";

export class OrderDeliverTo {
  ID: number;
  order_ID: number;
  title: string;
  firstname: string;
  lastname: string;
  company: string;
  address1: string;
  address2: string;
  address3: string;
  address4: string;
  city: string;
  state: string;
  country: string;
  carrier: string;
  servicelevel: string;
  phonecountry: string;
  phone: string;
  email: string;
  addresstype: string;
  carriertrackingid: string;
  carrierstatus: string;
  lastupdate: Date;
  shiptimestamp: Date;
  deliverytimestamp: Date;
  postalcode: string;
  packingSlipMimeType: string;
  packingSlipFormat: string;
  packingSlip: string;
  requestedPrintNodeName: string;
  inventoryType: string;
  addressValidationStatus: string;
  addressValidationMessage: string;
  invoice_ID: number;
  replenishmentFacility_ID: number;

  /**
   * Optional manufacturing routing hint (see
   * docs/contracts/shared/ReplenishmentOrder.md).
   *
   * When > 0 the server MUST create the resulting PrintNodeOrder with
   * `PrintNodeOrder.printnode_ID = requestedPrintNode_ID` rather than
   * running its normal facility-selection logic. 0 (the default) means
   * "route normally" and preserves the pre-existing behaviour.
   *
   * This exists because replenishment is always manufactured at the
   * facility whose shelf is being refilled - there is nothing to route.
   *
   * REQUEST-ONLY - this does NOT round-trip (server, 2026-08-27). It is
   * accepted on the create payload, used while the PrintNodeOrder is built,
   * then discarded; nothing is persisted to `orderdeliverto` and the planned
   * migration was cancelled. A later GET of this OrderDeliverTo returns 0.
   * Do not assert it survives, and do not read it back to find out where the
   * order went - the durable record is `PrintNodeOrder.printnode_ID`.
   */
  requestedPrintNode_ID: number;

  /**
   * Optional manufacturing routing hint (see
   * docs/contracts/shared/ReplenishmentOrder.md).
   *
   * When > 0 every PrintNodeOrderItem the server creates from this
   * OrderDeliverTo MUST be created with
   * `PrintNodeOrderItem.manufacturingset_ID = requestedManufacturingSet_ID`.
   * 0 (the default) means "leave unassigned", which is the
   * pre-existing behaviour.
   *
   * Set together with `requestedPrintNode_ID` so a replenishment that
   * is being used to fill out a press set lands in that set in the
   * same round trip. Doing it as a follow-up update is not possible
   * from the client: the PrintNodeOrder / PrintNodeOrderItem rows are
   * created asynchronously and do not exist yet when the POST returns.
   *
   * REQUEST-ONLY - see the note on `requestedPrintNode_ID`. The durable
   * record is `PrintNodeOrderItem.manufacturingset_id`.
   */
  requestedManufacturingSet_ID: number;

  orderItems: OrderItem[];

  order: Order;

  constructor( obj ) {
    this.order_ID = 0;
    this.title = '';
    this.firstname = '';
    this.lastname = '';
    this.company = '';
    this.address1 = '';
    this.address2 = '';
    this.address3 = '';
    this.address4 = '';
    this.city = '';
    this.state = '';
    this.country = 'US';
    this.carrier = '';
    this.servicelevel = '';
    this.phonecountry = 'US';
    this.phone = '';
    this.email = '';
    this.addresstype = '';
    this.carriertrackingid = '';
    this.carrierstatus = '';
    this.lastupdate = new Date();
    this.shiptimestamp = new Date(0);
    this.deliverytimestamp = new Date(0);
    this.postalcode = '';
    this.packingSlipMimeType = '';
    this.packingSlipFormat = '';
    this.packingSlip = 'string';
    this.requestedPrintNodeName = '';
    this.replenishmentFacility_ID = 0;
    this.requestedPrintNode_ID = 0;
    this.requestedManufacturingSet_ID = 0;
    this.orderItems = [];

    if ( obj ) {
      for ( const prop of Object.keys(obj) ) {
        this[prop] = obj[prop];
      }
      if ( obj.orderItems ) {
        this.orderItems = [];
        for ( const orderItem of obj.orderItems ) {
          this.orderItems.push( new OrderItem( orderItem ) );
        }
      }
      if ( obj.order ) {
        this.order = new Order( obj.order );
      }

    }

  }
}
